import React, { Component } from 'react';
import { Modal, Alert } from 'react-bootstrap';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import orderBy from 'lodash/orderBy';
import classnames from 'classnames';
import {getTagsList, getTagListByService, setTagsList, setTags, getAssignedTags } from '../../actions/tags';
import {modifyCall} from '../../actions/call';
import Loader from '../Components/Loader';
import { logData } from '../../utils/utils';
import "../../agent/Styles/darktheme.css";
import "../../agent/Styles/blacktheme.css";
import "../../agent/Styles/highContrast.css";

class SetTagsModal extends Component {

    constructor(props) {
        super(props);
        this.state = {
          selectedTags: [],
          showErr: false,
          errorHeight: 0,
          searchFilter: ''
        };
      }
    

      // gets list of tags from api call
      getTagList = () => {
        this.setState({
          loading: true,
          searchFilter: ''
        }, () => {
          // console.log('CallId: ', this.props.CallId);
          // console.log('serviceId: ', this.props.serviceId);
          // No necesario pasar parametro, OLD: this.props.getTagsList(this.props.CallId).then(() => {
          // NEW: this.props.getTagsList().then(() => {
          this.props.getTagListByService(this.props.serviceId).then((data) => {
            if (data.length === 0)
            {
                // No tiene tags por servicio.
                // Segunda busqueda, tags por cliente.
                this.props.getTagsList().then((data_total) => {
					this.props.setTagsList(data_total);
                    this.setState({
                      loading: false
                    })
                }, (err) => {
                  logData(err);
                });
            }
            else
            {
                // Tiene tags por servicio.
                this.props.setTagsList(data);
                this.setState({
                  loading: false
                })
            }
          }, (err) => {
            logData(err);
          });
        })
      }

      getAssignedTags = () => {
        this.props.getAssignedTags(this.props.CallId).then((response) => {
            const assignedTagIds = response.data.response.items.map(tag => parseInt(tag.id, 10));
            this.setState({ selectedTags: assignedTagIds });
        }, (err) => {
            
            logData(err);
        });
    }
  
    
      /**
       * closes the modal
       * @param  {string} key
       */
      close = (key) => {
        this.setState({
          selectedTags: [],
          showErr: false
        }, () => {
          this.props.handleClose(key);
        });
      }
    
      // updates selected tags
      toggleTagSelection = (tagId) => {
        this.setState((prevState) => {
          const selectedTags = prevState.selectedTags.includes(tagId)
            ? prevState.selectedTags.filter(id => id !== tagId)
            : [...prevState.selectedTags, tagId];
          return { selectedTags };
        });
      }
    
      // closes alert
      handleAlertDismiss = () => {
        this.setState({
          showErr: false
        });
      }
    
      getErrorHeight = () => {
        if (document.getElementById('tags_alertWrapper')) {
          const errorHeight = document.getElementById('tags_alertWrapper').clientHeight;
          this.setState({
            errorHeight: errorHeight + 21
          });
        }
      }
    
      // updates state with search filter value
      handleSearchChange = (e) => {
        this.setState({
          searchFilter: e.target.value
        });
      }
    
      // renders list of tags
    //   renderList = () => {
    //     let selection = new Set(this.state.selectedTags.map(id => parseInt(id, 10)));
    //     return orderBy(this.props.tagsList, [data => data.name ? data.name.toLowerCase() : ''], ['asc'])
    //       .filter(tag => tag.name && tag.name.toLowerCase()
    //         .includes(this.state.searchFilter.toLowerCase()))
    //       .map(item => {
    //         if (item.name) {
    //           return (
    //             <button
    //               key={item.id}
    //               type="button"
    //               onClick={() => this.toggleTagSelection(item.id)}
    //               className={classnames(`list-group-item list-group-item${this.props.theme}`, { active: selection.has(item.id) })}>
    //               {item.name}
    //             </button>
    //           )
    //         }
    //       });
    //   }
    
    
    renderList = () => {
        let selection = this.state.selectedTags;
        return orderBy(this.props.tagsList, [data => data.name ? data.name.toLowerCase() : ''], ['asc'])
          .filter(tag => tag.name && tag.name.toLowerCase()
            .includes(this.state.searchFilter.toLowerCase()))
          .map(item => {
            if (item.name) {
              return (
                <button
                  key={item.id}
                  type="button"
                  onClick={() => this.toggleTagSelection(item.id)}
                  className={classnames(`list-group-item list-group-item${this.props.theme}`, { active: selection.includes(item.id) })}>
                  {item.name}
                </button>
              )
            }
          });
      }

      // submits the selected tags
  handleSubmit = () => {
    const payload = {
      call_id: this.props.CallId,
      tags: JSON.stringify(this.state.selectedTags)
    }
    // makes api call from action
    this.props.setTags(payload).then((res) => {
      if (res.data.result === true) {
        const newData = {
          id: this.props.CallId,
          has_tags:this.state.selectedTags !== -1 ? true : false,
        };
        this.setState({
          selectedTags:[],
          showErr: false
        }, () => {
          this.props.getCalls()
          this.props.handleClose(this.props.showModal);
        });
      } else {
        this.setState({
          errorMsg: res.data.description || this.props.translations.commonErrorText[this.props.selectedLanguage],
          showErr: false
        }, () => {
          this.getErrorHeight();
        });
      }
    }, (err) => {
      logData(err);
      this.setState({
        errorMsg: this.props.translations.commonErrorText[this.props.selectedLanguage],
        showErr: false
      }, () => {
        this.getErrorHeight();
      });
    });
  }

  handleEnter = () => {
    this.getTagList();
    this.getAssignedTags();
  }
      render() {
        const {
          loading,
          showErr,
          errorHeight
        } = this.state;
        const { translations, selectedLanguage, tagsList } = this.props;
      
        return (
          <Modal
            onEnter={this.handleEnter}
            show={this.props.showModal}
            onHide={() => this.close('showModal')}
            bsSize="sm"
            backdrop="static"
          >
            <Modal.Header className={`modal-content${this.props.theme} modal-header${this.props.theme}`} closeButton>
              <Modal.Title>{translations.tagList[selectedLanguage]}</Modal.Title>
            </Modal.Header>
            <Modal.Body className={`modal-content${this.props.theme}`}>
              {showErr && <div className="alertWrapper" id="bo_alertWrapper"><Alert bsStyle="danger" onDismiss={this.handleAlertDismiss}>
                <p>{this.state.errorMsg}</p>
              </Alert></div>}
              {(!loading && tagsList.length > 0) &&
                <div className="input-with-icon w-full">
                  <input
                    type="text"
                    className={`form-control${this.props.theme} input-smm${this.props.theme}`}
                    placeholder={translations.search[selectedLanguage]}
                    style={{ marginBottom: '0.5rem' }}
                    onChange={this.handleSearchChange}
                  />
                  <span className="icon icon-magnifying-glass" />
                </div>}
              {loading && <Loader width="20px" height="20px" />}
              <div className="list-group" style={{ maxHeight: showErr ? `calc(345px - ${errorHeight}px)` : 345, overflow: 'auto' }}>
                {(!loading) && this.renderList()}
                {(!loading && tagsList.length == 0) &&
                  <h5>{translations.noneAssigned[selectedLanguage]}</h5>
                }
              </div>
            </Modal.Body>
            <Modal.Footer className={`modal-content${this.props.theme}`}>
              <button
                type="button"
                onClick={() => this.close('showModal')}
                className={`btn-link btn-link${this.props.theme} modal-action${this.props.theme}`}
                data-dismiss="modal"
                style={{ width: !loading && tagsList.length > 0 ? '50%' : '100%' }}
              >
                {translations.cancel[selectedLanguage]}
              </button>
              {(!loading && tagsList.length > 0) && <button type="submit" onClick={this.handleSubmit} className={`btn-link btn-link${this.props.theme} modal-action${this.props.theme}`} data-dismiss="modal">
                <strong>{translations.save[selectedLanguage]}</strong>
              </button>}
            </Modal.Footer>
          </Modal>
        )
      }
    }
    
    function mapStateToProps(state) {
      return {
        agentConfig: state.agentConfig,
        agentInfo: state.agentInfo,
        tagsList: state.tagsList,
        translations: state.languages.translations,
        selectedLanguage: state.languages.selectedLanguage,
        darkMode: state.common.darkMode,
        theme: state.common.theme,
      };
    }
    function mapDispatchToProps(dispatch) {
      return bindActionCreators({ getTagsList, getTagListByService, setTagsList, setTags, getAssignedTags, modifyCall }, dispatch);
    }
    
    export default connect(mapStateToProps, mapDispatchToProps)(SetTagsModal);


// WEBPACK FOOTER //
// ./src/agent/modals/setTagsModal.js